/* eslint-disable jsx-a11y/anchor-is-valid */
import isEmpty from 'lodash.isempty';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import InformationList from '../../../InformationList/InformationList';
import InformationListItem from '../../../InformationList/InformationListItem';
import Anchor from '../../../Anchor/Anchor';
import Paragraph from '../../../Paragraph/Paragraph';
import { formatMailingAddress } from '../../../../util/helpers/addressHelper';

const EquityWireTab = ({
  trusteeDetails,
  wireDetails,
  isPrefunded,
  showAltNotice,
}) => {
  const { t } = useTranslation();

  if (isEmpty(wireDetails)) {
    return null;
  }

  return (
    <>
      {!isPrefunded && (
        <div>
          <Paragraph marginBottom={24} fontSize={14}>
            {t('depositWizard.equity.wire.completeFormAtBank')}
          </Paragraph>
          {showAltNotice ? (
            <Paragraph marginBottom={24} fontSize={14}>
              {t('depositWizard.equity.wire.textOneAlt')}
            </Paragraph>
          ) : (
            <Paragraph marginBottom={24} fontSize={14}>
              {t('depositWizard.equity.wire.textOne')}
            </Paragraph>
          )}
        </div>
      )}
      <InformationList>
        <InformationListItem
          label={t('depositWizard.equity.bank')}
          value={
            <span>
              {formatMailingAddress(
                wireDetails.BankAddress,
                wireDetails.BankName,
              )}
            </span>
          }
        />
        <InformationListItem
          label={t('depositWizard.equity.routingAba')}
          value={wireDetails.RoutingAbaNumber}
        />
        <InformationListItem
          label={t('depositWizard.equity.accountNumber')}
          value={wireDetails.AccountNumber}
        />
        <InformationListItem
          label={t('depositWizard.equity.beneficiary')}
          value={wireDetails.PayableTo}
        />
        <InformationListItem
          label={t('depositWizard.equity.memo')}
          value={wireDetails.Memo}
        />
      </InformationList>
      <Paragraph marginTop={24} marginBottom={24} fontSize={14}>
        <strong>{t('depositWizard.equity.note')}</strong>
        {t('depositWizard.equity.wire.textTwo')}
      </Paragraph>
      <Paragraph marginBottom={24} fontSize={14}>
        {t('depositWizard.equity.wire.textThree')}
      </Paragraph>
      {trusteeDetails?.Url && (
        <Paragraph fontSize={14}>
          {t('depositWizard.equity.wire.additional')}
          <br />
          <Anchor
            type="website"
            value={`${trusteeDetails.Url}/incoming-wire-instructions`}
          />
        </Paragraph>
      )}
    </>
  );
};

EquityWireTab.propTypes = {
  wireDetails: PropTypes.shape({
    BankName: PropTypes.string,
    BankAddress: PropTypes.shape({
      AddressLine: PropTypes.string,
      City: PropTypes.string,
      PostalCode: PropTypes.string,
      StateRegion: PropTypes.string,
    }),
    RoutingAbaNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    AccountNumber: PropTypes.string,
    PayableTo: PropTypes.string,
    Memo: PropTypes.string,
  }),
  trusteeDetails: PropTypes.shape({
    Url: PropTypes.string,
  }),
  isPrefunded: PropTypes.bool,
  showAltNotice: PropTypes.bool,
};

export default EquityWireTab;
